import {
  FETCH_CANDIDATE_DETAILS_REQUEST,
  FETCH_CANDIDATE_DETAILS_SUCCESS,
  FETCH_CANDIDATE_DETAILS_FAILURE,
} from "../../actionTypes";

export const fetchCandidateDetailRequest = (data) => ({
  type: FETCH_CANDIDATE_DETAILS_REQUEST,
  payload: data,
});

export const fetchCandidateDetailSuccess = (data) => ({
  type: FETCH_CANDIDATE_DETAILS_SUCCESS,
  payload: data,
});

export const fetchCandidateDetailFailure = (error) => ({
  type: FETCH_CANDIDATE_DETAILS_FAILURE,
  payload: error,
});


